import API from './config';

const ServerFilesController = {
    getFilesByDir: async (body) => {

        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        }

        try {

            const response = await API.post('/server_files/getFilesByDir', body, config)

            return {
                success: true,
                body: response.data
            };

        } catch (error) {

            console.log("ERROR");

            return {
                success: false,
                body: error.response ? error.response.data : 'NO_DATA_ERROR'
            };
        }

    },

    /**
     * 
     * @param {string[]} filePaths 
     * @returns {Promise<import('axios').AxiosResponse<{
     *  presignedUrl: string;
     * }>>}
     */
    downloadFile: async (body) => {
        /**
         * @type {import('axios').AxiosRequestConfig}
         */
        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            },
        };

        return API.post('/server_files/download', body, config);
    },
    downloadRecursive: async (dir) => {
        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        };

        return API.post('/server_files/downloadRecursive', { dir }, config);
    },
    /**
     * 
     * @param {string} folder
     */
    createNewFolder: async (folder) => {
        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        };

        return API.post('/server_files/createNewFolder', { folder }, config);
    },
    uploadFiles: (formData) => {
        let config = {
            headers: {
                'Content-Type': 'multipart/form-data',
                'x-access-token': localStorage.getItem('token'),
            },
            maxBodyLength: 20 * 1024 * 1024,
        };

        return API.post(`/server_files/uploadFiles`, formData, config);
    },
    deleteByPaths: async (keys) => {
        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            },
            data: { keys }
        };

        return API.delete('/server_files/deleteByPaths', config);
    },
    downloadByPaths: async (keys) => {
        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            },
            data: { keys }
        };

        return API.get('/server_files/downloadByPaths', config);
    },

    uploadMultipleFiles: async (files, path, is_client_accreditation_zone) => {
        const MAX_FILE_SIZE = 20 * 1024 * 1024;

        const uploads = files.map(async (file) => {
            if (is_client_accreditation_zone && file.size > MAX_FILE_SIZE) {
                return "MAX_FILE_SIZE_EXCEEDED";
            }

            const { data: { data: presignedUrl } } = await API.get(
                '/server_files/generate-upload-url',
                {
                    headers: {
                        'x-access-token': localStorage.getItem('token'),
                    },
                    params: {
                        file_name: file.name,
                        path,
                        content_type: file.type,
                        is_client_accreditation_zone,
                        file_size: file.size, // opcional, ver item 2 abaixo
                    },
                },
            );

            try {
                await API.put(presignedUrl, file, {
                    headers: {
                        'Content-Type': file.type || 'application/octet-stream',
                    },
                    maxBodyLength: Infinity,
                });

                return {
                    fileName: file.name,
                    status: 'uploaded',
                };
            } catch (error) {
                console.log('Error: ', error);
                return {
                    fileName: file.name,
                    status: 'error',
                    error: 'Falha ao enviar arquivo',
                };
            }
        });

        return Promise.all(uploads);
    },

    getXmlFundCompositionPresignedUrl: async (fund_id, year, month_key) => {
        let config = {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            }
        };

        try {
            const response = await API.post('/server_files/getXmlFundCompositionPresignedUrl', { fund_id, year, month_key }, config);
            return {
                success: true,
                found: response.data.found,
                presignedUrl: response.data.presignedUrl,
            };
        } catch (error) {
            return { success: false, found: false };
        }
    },

    getPresignedUrl: async (path, file) => {

        console.log("Path: ", path);
        console.log("File: ", file);
        console.log("file.originalname: ", file.originalname);
        console.log("file.mimetype: ", file.mimetype);

        const responsePreSigned = await API.get('/server_files/generate-upload-url', {
            headers: {
                'x-access-token': localStorage.getItem('token'),
            },
            params: {
                file_name: file.name,
                path: path,
                content_type: file.mimetype,
            }
        });

        const { data } = responsePreSigned;
        if (data.url) {

            console.log("responsePreSigned: ", data.url);
            // console.log("responsePreSigned: ", file.buffer);

            await API.put(data.url, file, {
                headers: {
                    'Content-Type': 'application/octet-stream',
                },
                maxBodyLength: Infinity,
            });
        }


    }




};

export default ServerFilesController;